import { Col, Container, Row } from "react-bootstrap";
import whoImg from "../../../assets/about/who.png";
import howImg from "../../../assets/about/how.png";
import whatImg from "../../../assets/about/what.png";
import whoImg_es from "../../../assets/about/who_es.png";
import howImg_es from "../../../assets/about/how_es.png";
import whatImg_es from "../../../assets/about/what_es.png";
import tanque from "../../../assets/about/woppartners_tanque.png";
import praset from "../../../assets/about/woppartners_praset.png";
import crabsense from "../../../assets/about/woppartners_crabsense.png";
import avra from "../../../assets/about/woppartners_avra.png";
import toropinto from "../../../assets/about/woppartners_toropinto.png";
import tokyo from "../../../assets/about/woppartners_tokio.png";
import delenio from "../../../assets/about/woppartners_delenio.png";
import partnerpress from "../../../assets/about/woppartners_partnerpress.png";
import paxzu from "../../../assets/about/woppartners_paxzu.png";
import { Link } from "react-router-dom";
import * as ReactTranslated from "react-translated";
import { UserProvider } from "../../../router/AppProvider";
import { useContext } from "react";

const WhoWeAre = () => {
  const { language } = useContext(UserProvider);
  return (
    <Container>
      <Row className="boxWhoWheAre">
        <Col md={6} xs={11} className="d-flex justify-content-center align-content-center align-items-center mx-auto">
          <div>
            {language === "en" ? (
              <img src={whoImg} className="img-fluid" alt="Who we are" />
            ) : (
              <img src={whoImg_es} className="img-fluid" alt="Quiénes somos" />
            )}
          </div>
        </Col>
        <Col
          md={6}
          xs={11}
          className="d-flex flex-column justify-content-center justify-content-start mx-auto pt-md-0 pt-5"
        >
          <div>
            <p className="lightTxt">
              <ReactTranslated.Translate text="contenidoWhoweare" />
            </p>
          </div>
          <div className="pt-3 pb-3">
            <Link to="/team" className="link-default">
              <ReactTranslated.Translate text="contenidoWhoweare2" />
            </Link>
          </div>
        </Col>
      </Row>

      <Row className="boxWhoWheAre">
        <Col md={6} xs={11} className="d-flex justify-content-center align-content-center align-items-center mx-auto">
          <div>
            {language === "en" ? (
              <img src={whatImg} className="img-fluid" alt="What we do" />
            ) : (
              <img src={whatImg_es} className="img-fluid" alt="Qué hacemos" />
            )}
          </div>
        </Col>
        <Col
          md={6}
          xs={11}
          className="d-flex flex-column justify-content-center justify-content-start mx-auto pt-md-0 pt-5"
        >
          <div>
            <p className="lightTxt">
              {" "}
              <ReactTranslated.Translate text="contenidoWhatwedo" />
            </p>
          </div>
          <div className="pt-3 pb-3">
            <Row>
              <Col>
                <ul className="list-unstyled list-what-we-do">
                  <li>
                    <ReactTranslated.Translate text="titleServices1" />
                  </li>
                  <li>
                    <ReactTranslated.Translate text="titleServices2" />
                  </li>{" "}
                  <li>
                    <ReactTranslated.Translate text="titleServices3" />
                  </li>{" "}
                  <li>
                    <ReactTranslated.Translate text="titleServices4" />
                  </li>{" "}
                  <li>
                    <ReactTranslated.Translate text="titleServices5" />
                  </li>{" "}
                  <li>
                    <ReactTranslated.Translate text="titleServices6" />
                  </li>
                  <li>
                    <ReactTranslated.Translate text="titleServices6b" />
                  </li>
                  <li>
                    <ReactTranslated.Translate text="titleServices7" />
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row className="boxWhoWheAre">
        <Col md={6} xs={11} className="d-flex justify-content-center align-content-center align-items-center mx-auto">
          <div>
            {language === "en" ? (
              <img src={howImg} className="img-fluid" alt="How we do it" />
            ) : (
              <img src={howImg_es} className="img-fluid" alt="Cómo lo hacemos" />
            )}
          </div>
        </Col>
        <Col
          md={6}
          xs={11}
          className="d-flex flex-column justify-content-center justify-content-start mx-auto pt-md-0 pt-5"
        >
          <div>
            <p className="lightTxt">
              <ReactTranslated.Translate text="contenidoHowwedoit" />
            </p>
          </div>
          <div className="pt-3 pb-3">
            {" "}
            <p>
              <ReactTranslated.Translate text="contenidoHowwedoPresent" />
            </p>
          </div>
          <Row>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://tanque.ar/" target="_blank" rel="noopener noreferrer">
                <img src={tanque} className="img-fluid" alt="Tanque" />
              </a>
            </Col>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://praset.com/" target="_blank" rel="noopener noreferrer">
                <img src={praset} className="img-fluid" alt="Praset" />
              </a>
            </Col>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://crabsense.com/" target="_blank" rel="noopener noreferrer">
                <img src={crabsense} className="img-fluid mt-2 ms-2" alt="CrabSense" />
              </a>
            </Col>
          </Row>
          <Row>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://avradev.com/" target="_blank" rel="noopener noreferrer">
                <img src={avra} className="img-fluid" alt="AVRA" />
              </a>
            </Col>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://toro-pinto.com/" target="_blank" rel="noopener noreferrer">
                <img src={toropinto} className="img-fluid" alt="Toro Pinto" />
              </a>
            </Col>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://studiotokyo.com.ar/" target="_blank" rel="noopener noreferrer">
                <img src={tokyo} className="img-fluid" alt="Studio Tokyo" />
              </a>
            </Col>
          </Row>
          <Row>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://delenio.net/" target="_blank" rel="noopener noreferrer">
                <img src={delenio} className="img-fluid" alt="Delenio" />
              </a>
            </Col>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://www.partner-press.com/" target="_blank" rel="noopener noreferrer">
                <img src={partnerpress} className="img-fluid" alt="Partner Press" />
              </a>
            </Col>
            <Col md={4} xs={6} className="text-center pt-4">
              <a href="https://www.paxzu.com/" target="_blank" rel="noopener noreferrer">
                <img src={paxzu} className="img-fluid" alt="Paxzu" />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default WhoWeAre;
